<template>
  <footer class="text-center mt-4">
    <p style="font-size: 13px">
      ©{{ new Date().getFullYear() }}
      <a target="_blank" style="text-decoration: none" href="https://bitlab.rs/">
        {{ toLatin("БитЛаб д.о.о") }}
      </a>
      {{ $t("all_rights_reserved") }}.
      <a target="_blank" style="text-decoration: none" href="https://privacy.ordera.app/">
        {{ $t("privacy_policy") }}
      </a>
    </p>
    <p v-if="version" class="text--secondary mb-0" style="font-size: 12px">
      {{ $t("app_version") }}: {{ version }}
    </p>
  </footer>
</template>

<script>
import { getAppVersion } from "@/utils/appMaintenance";

export default {
  name: "AppFooter",
  computed: {
    version() {
      return getAppVersion();
    },
  },
};
</script>
